/* eslint-disable no-unused-vars */
"use strict";

var _asyncToGenerator = require("/home/runner/work/asc-development-web/asc-development-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

var $Refs = require("./refs");

var _parse = require("./parse");

var normalizeArgs = require("./normalize-args");

var resolveExternal = require("./resolve-external");

var _bundle = require("./bundle");

var _dereference = require("./dereference");

var url = require("./util/url");

var _require = require("./util/errors"),
    JSONParserError = _require.JSONParserError,
    InvalidPointerError = _require.InvalidPointerError,
    MissingPointerError = _require.MissingPointerError,
    ResolverError = _require.ResolverError,
    ParserError = _require.ParserError,
    UnmatchedParserError = _require.UnmatchedParserError,
    UnmatchedResolverError = _require.UnmatchedResolverError,
    isHandledError = _require.isHandledError,
    JSONParserErrorGroup = _require.JSONParserErrorGroup;

var maybe = require("call-me-maybe");

var _require2 = require("@jsdevtools/ono"),
    ono = _require2.ono;

module.exports = $RefParser;
module.exports.default = $RefParser;
module.exports.JSONParserError = JSONParserError;
module.exports.JSONParserErrorGroup = JSONParserErrorGroup;
module.exports.InvalidPointerError = InvalidPointerError;
module.exports.MissingPointerError = MissingPointerError;
module.exports.ResolverError = ResolverError;
module.exports.ParserError = ParserError;
module.exports.UnmatchedParserError = UnmatchedParserError;
module.exports.UnmatchedResolverError = UnmatchedResolverError;
/**
 * This class parses a JSON schema, builds a map of its JSON references and their resolved values,
 * and provides methods for traversing, manipulating, and dereferencing those references.
 *
 * @constructor
 */

function $RefParser() {
  /**
   * The parsed (and possibly dereferenced) JSON schema object
   *
   * @type {object}
   * @readonly
   */
  this.schema = null;
  /**
   * The resolved JSON references
   *
   * @type {$Refs}
   * @readonly
   */

  this.$refs = new $Refs();
}
/**
 * Parses the given JSON schema.
 * This method does not resolve any JSON references.
 * It just reads a single file in JSON or YAML format, and parse it as a JavaScript object.
 *
 * @param {string} [path] - The file path or URL of the JSON schema
 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed
 * @param {function} [callback] - An error-first callback. The second parameter is the parsed JSON schema object.
 * @returns {Promise} - The returned promise resolves with the parsed JSON schema object.
 */


$RefParser.parse = function parse(path, schema, options, callback) {
  var Class = this; // eslint-disable-line consistent-this

  var instance = new Class();
  return instance.parse.apply(instance, arguments);
};
/**
 * Parses the given JSON schema.
 * This method does not resolve any JSON references.
 * It just reads a single file in JSON or YAML format, and parse it as a JavaScript object.
 *
 * @param {string} [path] - The file path or URL of the JSON schema
 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed
 * @param {function} [callback] - An error-first callback. The second parameter is the parsed JSON schema object.
 * @returns {Promise} - The returned promise resolves with the parsed JSON schema object.
 */


$RefParser.prototype.parse = /*#__PURE__*/function () {
  var _parse2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(path, schema, options, callback) {
    var args,
        promise,
        err,
        pathType,
        $ref,
        me,
        result,
        _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            args = normalizeArgs(_args);

            if (!(!args.path && !args.schema)) {
              _context.next = 4;
              break;
            }

            err = ono("Expected a file path, URL, or object. Got ".concat(args.path || args.schema));
            return _context.abrupt("return", maybe(args.callback, Promise.reject(err)));

          case 4:
            // Reset everything
            this.schema = null;
            this.$refs = new $Refs(); // If the path is a filesystem path, then convert it to a URL.
            // NOTE: According to the JSON Reference spec, these should already be URLs,
            // but, in practice, many people use local filesystem paths instead.
            // So we're being generous here and doing the conversion automatically.
            // This is not intended to be a 100% bulletproof solution.
            // If it doesn't work for your use-case, then use a URL instead.

            pathType = "http";

            if (url.isFileSystemPath(args.path)) {
              args.path = url.fromFileSystemPath(args.path);
              pathType = "file";
            } // Resolve the absolute path of the schema


            args.path = url.resolve(url.cwd(), args.path);

            if (args.schema && typeof args.schema === "object") {
              // A schema object was passed-in.
              // So immediately add a new $Ref with the schema object as its value
              $ref = this.$refs._add(args.path);
              $ref.value = args.schema;
              $ref.pathType = pathType;
              promise = Promise.resolve(args.schema);
            } else {
              // Parse the schema file/url
              promise = _parse(args.path, this.$refs, args.options);
            }

            me = this;
            _context.prev = 11;
            _context.next = 14;
            return promise;

          case 14:
            result = _context.sent;

            if (!(result !== null && typeof result === "object" && !ArrayBuffer.isView(result))) {
              _context.next = 20;
              break;
            }

            me.schema = result;
            return _context.abrupt("return", maybe(args.callback, Promise.resolve(me.schema)));

          case 20:
            if (!args.options.continueOnError) {
              _context.next = 25;
              break;
            }

            me.schema = null; // it's already set to null at line 79, but let's set it again for the sake of readability

            return _context.abrupt("return", maybe(args.callback, Promise.resolve(me.schema)));

          case 25:
            throw ono.syntax("\"".concat(me.$refs._root$Ref.path || result, "\" is not a valid JSON Schema"));

          case 26:
            _context.next = 34;
            break;

          case 28:
            _context.prev = 28;
            _context.t0 = _context["catch"](11);

            if (!(!args.options.continueOnError || !isHandledError(_context.t0))) {
              _context.next = 32;
              break;
            }

            return _context.abrupt("return", maybe(args.callback, Promise.reject(_context.t0)));

          case 32:
            if (this.$refs._$refs[url.stripHash(args.path)]) {
              this.$refs._$refs[url.stripHash(args.path)].addError(_context.t0);
            }

            return _context.abrupt("return", maybe(args.callback, Promise.resolve(null)));

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[11, 28]]);
  }));

  function parse(_x, _x2, _x3, _x4) {
    return _parse2.apply(this, arguments);
  }

  return parse;
}();
/**
 * Parses the given JSON schema and resolves any JSON references, including references in
 * externally-referenced files.
 *
 * @param {string} [path] - The file path or URL of the JSON schema
 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed and resolved
 * @param {function} [callback]
 * - An error-first callback. The second parameter is a {@link $Refs} object containing the resolved JSON references
 *
 * @returns {Promise}
 * The returned promise resolves with a {@link $Refs} object containing the resolved JSON references
 */


$RefParser.resolve = function resolve(path, schema, options, callback) {
  var Class = this; // eslint-disable-line consistent-this

  var instance = new Class();
  return instance.resolve.apply(instance, arguments);
};
/**
 * Parses the given JSON schema and resolves any JSON references, including references in
 * externally-referenced files.
 *
 * @param {string} [path] - The file path or URL of the JSON schema
 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed and resolved
 * @param {function} [callback]
 * - An error-first callback. The second parameter is a {@link $Refs} object containing the resolved JSON references
 *
 * @returns {Promise}
 * The returned promise resolves with a {@link $Refs} object containing the resolved JSON references
 */


$RefParser.prototype.resolve = /*#__PURE__*/function () {
  var _resolve = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(path, schema, options, callback) {
    var me,
        args,
        _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            me = this;
            args = normalizeArgs(_args2);
            _context2.prev = 2;
            _context2.next = 5;
            return this.parse(args.path, args.schema, args.options);

          case 5:
            _context2.next = 7;
            return resolveExternal(me, args.options);

          case 7:
            finalize(me);
            return _context2.abrupt("return", maybe(args.callback, Promise.resolve(me.$refs)));

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", maybe(args.callback, Promise.reject(_context2.t0)));

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this, [[2, 11]]);
  }));

  function resolve(_x5, _x6, _x7, _x8) {
    return _resolve.apply(this, arguments);
  }

  return resolve;
}();
/**
 * Parses the given JSON schema, resolves any JSON references, and bundles all external references
 * into the main JSON schema. This produces a JSON schema that only has *internal* references,
 * not any *external* references.
 *
 * @param {string} [path] - The file path or URL of the JSON schema
 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed, resolved, and dereferenced
 * @param {function} [callback] - An error-first callback. The second parameter is the bundled JSON schema object
 * @returns {Promise} - The returned promise resolves with the bundled JSON schema object.
 */


$RefParser.bundle = function bundle(path, schema, options, callback) {
  var Class = this; // eslint-disable-line consistent-this

  var instance = new Class();
  return instance.bundle.apply(instance, arguments);
};
/**
 * Parses the given JSON schema, resolves any JSON references, and bundles all external references
 * into the main JSON schema. This produces a JSON schema that only has *internal* references,
 * not any *external* references.
 *
 * @param {string} [path] - The file path or URL of the JSON schema
 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed, resolved, and dereferenced
 * @param {function} [callback] - An error-first callback. The second parameter is the bundled JSON schema object
 * @returns {Promise} - The returned promise resolves with the bundled JSON schema object.
 */


$RefParser.prototype.bundle = /*#__PURE__*/function () {
  var _bundle2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(path, schema, options, callback) {
    var me,
        args,
        _args3 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            me = this;
            args = normalizeArgs(_args3);
            _context3.prev = 2;
            _context3.next = 5;
            return this.resolve(args.path, args.schema, args.options);

          case 5:
            _bundle(me, args.options);

            finalize(me);
            return _context3.abrupt("return", maybe(args.callback, Promise.resolve(me.schema)));

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](2);
            return _context3.abrupt("return", maybe(args.callback, Promise.reject(_context3.t0)));

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[2, 10]]);
  }));

  function bundle(_x9, _x10, _x11, _x12) {
    return _bundle2.apply(this, arguments);
  }

  return bundle;
}();
/**
 * Parses the given JSON schema, resolves any JSON references, and dereferences the JSON schema.
 * That is, all JSON references are replaced with their resolved values.
 *
 * @param {string} [path] - The file path or URL of the JSON schema
 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed, resolved, and dereferenced
 * @param {function} [callback] - An error-first callback. The second parameter is the dereferenced JSON schema object
 * @returns {Promise} - The returned promise resolves with the dereferenced JSON schema object.
 */


$RefParser.dereference = function dereference(path, schema, options, callback) {
  var Class = this; // eslint-disable-line consistent-this

  var instance = new Class();
  return instance.dereference.apply(instance, arguments);
};
/**
 * Parses the given JSON schema, resolves any JSON references, and dereferences the JSON schema.
 * That is, all JSON references are replaced with their resolved values.
 *
 * @param {string} [path] - The file path or URL of the JSON schema
 * @param {object} [schema] - A JSON schema object. This object will be used instead of reading from `path`.
 * @param {$RefParserOptions} [options] - Options that determine how the schema is parsed, resolved, and dereferenced
 * @param {function} [callback] - An error-first callback. The second parameter is the dereferenced JSON schema object
 * @returns {Promise} - The returned promise resolves with the dereferenced JSON schema object.
 */


$RefParser.prototype.dereference = /*#__PURE__*/function () {
  var _dereference2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(path, schema, options, callback) {
    var me,
        args,
        _args4 = arguments;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            me = this;
            args = normalizeArgs(_args4);
            _context4.prev = 2;
            _context4.next = 5;
            return this.resolve(args.path, args.schema, args.options);

          case 5:
            _dereference(me, args.options);

            finalize(me);
            return _context4.abrupt("return", maybe(args.callback, Promise.resolve(me.schema)));

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](2);
            return _context4.abrupt("return", maybe(args.callback, Promise.reject(_context4.t0)));

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this, [[2, 10]]);
  }));

  function dereference(_x13, _x14, _x15, _x16) {
    return _dereference2.apply(this, arguments);
  }

  return dereference;
}();

function finalize(parser) {
  var errors = JSONParserErrorGroup.getParserErrors(parser);

  if (errors.length > 0) {
    throw new JSONParserErrorGroup(parser);
  }
}